import React from 'react';
import useAxios from 'axios-hooks';
import { useParams } from 'react-router-dom';

import Api from '../../api';
import { ServiceLink } from '../../components';

const Services = ({}) => {

  const [{ data, loading, error }] = useAxios({ url: Api.services });
  const services_list =
    data &&
    data.services.length > 0 &&
    data.services.map((item) => {
      return (
        <ServiceLink key={item.id} to={`/services/${item.slug}`} title={item.title} description={item.description} />
      );
    });
  return (
    <div className="app main-container">
      { loading && <p>Loading...</p> }
      { error && <p>Error...</p> }
      { services_list && (
        <div className="wrap holder">
          <div className="services-list">
            {services_list}

            <ServiceLink
              key={3435}
              to={`/produce`}
              title="Производственникам"
              description="Активно работаем с&nbsp;производственными предприятиями со&nbsp;всей России, создавая комплексные решения для развития."
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Services;
